import $ from 'jquery';

import * as MessageStore from './../stores/message-store';
import * as LanguageStore from './../stores/language-store';

let messageId = 0;
let messages = [];
let messages_cn = [];
let timer = null;
const scrollTime = 5000;

export function initMesssage() {
    messages.push(...choppedWord(MessageStore.get().message, 'en'));
    // messages_cn.push(...choppedWord(MessageStore.get().message_cn,'cn'));
    insertMessage();
}


function choppedWord(messages, lang) {
    let splitReg = (lang === 'cn')? '' : ' ';
    let className = (lang === 'cn')? 'chinese' : '';
    return messages.map( (message) => {
        const splitMessage = message.split(splitReg);
        const word = splitMessage.map( (innerWord) => {
            let space = '';
            if( (lang === 'cn' && innerWord === 's') || (lang === 'en' && innerWord === '\\s')) {
                space ='space';
                innerWord = '';
            }

            return `<div class="message__text__mask ${className} ${space}"><span>${innerWord + splitReg}</span></div>`
        }).join('');
        return `<div class="message__text__inner ${className}">${word}</div>`;
    });
}

export function msgSlideOut() {
    $('.message').removeClass('in').addClass('out');
    stopScroll();
}

export function msgSlideIn() {
    $('.message').removeClass('out').addClass('in');
    startScroll();
}

export function updateContents() {
    $('.message__text').html('');

    clearTimer();
    setTimeout( () => {
        insertMessage();
    },1000);
}

function insertMessage() {
    const lang = LanguageStore.get();

    if(lang === 'en') $('.message__text').append(messages)
    else $('.message__text').append(messages_cn);

    /* add id 0, 1, 2,... to  message__text__inner for scroll*/
    $('.message__text__inner').each( function(index) {
        $(this).attr('id', 'message__text__inner-' + index);
    });
    startScroll();
}

export function startScroll() {
    toggleMessage('show');
    if(timer === null) {
        timer = setInterval( () => {
            toggleMessage('hide');
            messageId += 1;
            setTimeout( () => {
                toggleMessage('show');
            }, 500);
            if(messageId > messages.length - 1) {
                messageId = 0;
            }
        }, scrollTime);
    }
}

export function toggleMessage(state) {
    const msg = $(`#message__text__inner-${messageId}`);
    let delay = 0;

    msg.css('display', 'block');
    msg.find('span').each( function (index) { // eslint-disable-line func-names
        if(state === 'show') {
            delay = index * 0.05;
            $(this).css('-webkit-animation', `show-msg-ani 0.5s ease-out ${delay}s forwards`); // eslint-disable-line no-invalid-this
            $(this).css('animation', `show-msg-ani 0.5s ease-out ${delay}s forwards`); // eslint-disable-line no-invalid-this
        }else {
            delay = 0;
            $(this).css('-webkit-animation', `hide-msg-ani 0.5s ease-out ${delay}s forwards`); // eslint-disable-line no-invalid-this
            $(this).css('animation', `hide-msg-ani 0.5s ease-out ${delay}s forwards`); // eslint-disable-line no-invalid-this
        }
    });
}


export function stopScroll() {
    clearTimer();
}

function clearTimer() {
    clearInterval(timer);
    timer = null;
}





